import {
  Component,
  ElementRef,
  HostListener,
  Optional,
  Renderer2,
  Self,
  ViewChild,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'gl-slide-toggle',
    templateUrl: './slide-toggle.component.html',
    styleUrls: ['./slide-toggle.component.scss'],
    standalone: false
})
export class SlideToggleComponent implements ControlValueAccessor {
  @ViewChild('input', { static: true }) public input: ElementRef;
  private checked: boolean;
  constructor(
    @Optional()
    @Self()
    public controlDir: NgControl,
    private renderer: Renderer2,
    private elementRef: ElementRef,
  ) {
    if (controlDir) {
      controlDir.valueAccessor = this;
    }
  }
  @HostListener('click', ['$event']) public onclick(event: Event) {
    this.checked = !this.checked;
    event.preventDefault();
    this.propagateChange(this.checked);
    this.writeValue(this.checked);
  }

  public registerOnChange(fn: any): any {
    this.propagateChange = fn;
  }

  public registerOnTouched = (_: any) => undefined;

  public writeValue(value: any): void {
    this.checked = value;
    this.renderer.setProperty(this.input.nativeElement, 'value', value);
    this.renderer.setProperty(this.input.nativeElement, 'checked', value);
  }

  public setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
  }

  private propagateChange = (_: any) => undefined;
}
